var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a2, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a2, prop, b[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b) => __defProps(a2, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x2) => x2.done ? resolve(x2.value) : Promise.resolve(x2.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/Sidebar/index.tsx
import {
  Nav as Nav2
} from "@77sol-ui/molecules";

// src/Sidebar/Logo/index.tsx
import { forwardRef, useImperativeHandle, useRef } from "react";

// ../../node_modules/tailwind-variants/dist/chunk-JXBJZR5A.js
var l = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e;
var u = (e) => !e || typeof e != "object" || Object.keys(e).length === 0;
var x = (e, o) => JSON.stringify(e) === JSON.stringify(o);
function i(e, o) {
  e.forEach(function(r) {
    Array.isArray(r) ? i(r, o) : o.push(r);
  });
}
function y(e) {
  let o = [];
  return i(e, o), o;
}
var a = (...e) => y(e).filter(Boolean);
var p = (e, o) => {
  let r = {}, c = Object.keys(e), f = Object.keys(o);
  for (let t of c)
    if (f.includes(t)) {
      let s = e[t], n = o[t];
      typeof s == "object" && typeof n == "object" ? r[t] = p(s, n) : Array.isArray(s) || Array.isArray(n) ? r[t] = a(n, s) : r[t] = n + " " + s;
    } else
      r[t] = e[t];
  for (let t of f)
    c.includes(t) || (r[t] = o[t]);
  return r;
};
var g = (e) => !e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim();

// ../../node_modules/tailwind-merge/dist/lib/tw-join.mjs
function twJoin() {
  var index = 0;
  var argument;
  var resolvedValue;
  var string = "";
  while (index < arguments.length) {
    if (argument = arguments[index++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}
function toValue(mix) {
  if (typeof mix === "string") {
    return mix;
  }
  var resolvedValue;
  var string = "";
  for (var k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}

// ../../node_modules/tailwind-merge/dist/lib/class-utils.mjs
var CLASS_PART_SEPARATOR = "-";
function createClassUtils(config) {
  var classMap = createClassMap(config);
  var conflictingClassGroups = config.conflictingClassGroups, _config$conflictingCl = config.conflictingClassGroupModifiers, conflictingClassGroupModifiers = _config$conflictingCl === void 0 ? {} : _config$conflictingCl;
  function getClassGroupId(className) {
    var classParts = className.split(CLASS_PART_SEPARATOR);
    if (classParts[0] === "" && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  }
  function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
    var conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [].concat(conflicts, conflictingClassGroupModifiers[classGroupId]);
    }
    return conflicts;
  }
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
}
function getGroupRecursive(classParts, classPartObject) {
  var _a;
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  var currentClassPart = classParts[0];
  var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  var classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : void 0;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return void 0;
  }
  var classRest = classParts.join(CLASS_PART_SEPARATOR);
  return (_a = classPartObject.validators.find(function(_ref) {
    var validator = _ref.validator;
    return validator(classRest);
  })) == null ? void 0 : _a.classGroupId;
}
var arbitraryPropertyRegex = /^\[(.+)\]$/;
function getGroupIdForArbitraryProperty(className) {
  if (arbitraryPropertyRegex.test(className)) {
    var arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    var property = arbitraryPropertyClassName == null ? void 0 : arbitraryPropertyClassName.substring(0, arbitraryPropertyClassName.indexOf(":"));
    if (property) {
      return "arbitrary.." + property;
    }
  }
}
function createClassMap(config) {
  var theme = config.theme, prefix = config.prefix;
  var classMap = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  var prefixedClassGroupEntries = getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
  prefixedClassGroupEntries.forEach(function(_ref2) {
    var classGroupId = _ref2[0], classGroup = _ref2[1];
    processClassesRecursively(classGroup, classMap, classGroupId, theme);
  });
  return classMap;
}
function processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
  classGroup.forEach(function(classDefinition) {
    if (typeof classDefinition === "string") {
      var classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === "function") {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(function(_ref3) {
      var key = _ref3[0], classGroup2 = _ref3[1];
      processClassesRecursively(classGroup2, getPart(classPartObject, key), classGroupId, theme);
    });
  });
}
function getPart(classPartObject, path) {
  var currentClassPartObject = classPartObject;
  path.split(CLASS_PART_SEPARATOR).forEach(function(pathPart) {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
}
function isThemeGetter(func) {
  return func.isThemeGetter;
}
function getPrefixedClassGroupEntries(classGroupEntries, prefix) {
  if (!prefix) {
    return classGroupEntries;
  }
  return classGroupEntries.map(function(_ref4) {
    var classGroupId = _ref4[0], classGroup = _ref4[1];
    var prefixedClassGroup = classGroup.map(function(classDefinition) {
      if (typeof classDefinition === "string") {
        return prefix + classDefinition;
      }
      if (typeof classDefinition === "object") {
        return Object.fromEntries(Object.entries(classDefinition).map(function(_ref5) {
          var key = _ref5[0], value = _ref5[1];
          return [prefix + key, value];
        }));
      }
      return classDefinition;
    });
    return [classGroupId, prefixedClassGroup];
  });
}

// ../../node_modules/tailwind-merge/dist/lib/lru-cache.mjs
function createLruCache(maxCacheSize) {
  if (maxCacheSize < 1) {
    return {
      get: function get() {
        return void 0;
      },
      set: function set() {
      }
    };
  }
  var cacheSize = 0;
  var cache = /* @__PURE__ */ new Map();
  var previousCache = /* @__PURE__ */ new Map();
  function update(key, value) {
    cache.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = /* @__PURE__ */ new Map();
    }
  }
  return {
    get: function get(key) {
      var value = cache.get(key);
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache.get(key)) !== void 0) {
        update(key, value);
        return value;
      }
    },
    set: function set(key, value) {
      if (cache.has(key)) {
        cache.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
}

// ../../node_modules/tailwind-merge/dist/lib/modifier-utils.mjs
var IMPORTANT_MODIFIER = "!";
function createSplitModifiers(config) {
  var separator = config.separator || ":";
  var isSeparatorSingleCharacter = separator.length === 1;
  var firstSeparatorCharacter = separator[0];
  var separatorLength = separator.length;
  return function splitModifiers(className) {
    var modifiers = [];
    var bracketDepth = 0;
    var modifierStart = 0;
    var postfixModifierPosition;
    for (var index = 0; index < className.length; index++) {
      var currentCharacter = className[index];
      if (bracketDepth === 0) {
        if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
          modifiers.push(className.slice(modifierStart, index));
          modifierStart = index + separatorLength;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index;
          continue;
        }
      }
      if (currentCharacter === "[") {
        bracketDepth++;
      } else if (currentCharacter === "]") {
        bracketDepth--;
      }
    }
    var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    var hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
    var baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
    var maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    };
  };
}
function sortModifiers(modifiers) {
  if (modifiers.length <= 1) {
    return modifiers;
  }
  var sortedModifiers = [];
  var unsortedModifiers = [];
  modifiers.forEach(function(modifier) {
    var isArbitraryVariant = modifier[0] === "[";
    if (isArbitraryVariant) {
      sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort().concat([modifier]));
      unsortedModifiers = [];
    } else {
      unsortedModifiers.push(modifier);
    }
  });
  sortedModifiers.push.apply(sortedModifiers, unsortedModifiers.sort());
  return sortedModifiers;
}

// ../../node_modules/tailwind-merge/dist/lib/config-utils.mjs
function createConfigUtils(config) {
  return __spreadValues({
    cache: createLruCache(config.cacheSize),
    splitModifiers: createSplitModifiers(config)
  }, createClassUtils(config));
}

// ../../node_modules/tailwind-merge/dist/lib/merge-classlist.mjs
var SPLIT_CLASSES_REGEX = /\s+/;
function mergeClassList(classList, configUtils) {
  var splitModifiers = configUtils.splitModifiers, getClassGroupId = configUtils.getClassGroupId, getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds;
  var classGroupsInConflict = /* @__PURE__ */ new Set();
  return classList.trim().split(SPLIT_CLASSES_REGEX).map(function(originalClassName) {
    var _splitModifiers = splitModifiers(originalClassName), modifiers = _splitModifiers.modifiers, hasImportantModifier = _splitModifiers.hasImportantModifier, baseClassName = _splitModifiers.baseClassName, maybePostfixModifierPosition = _splitModifiers.maybePostfixModifierPosition;
    var classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    var hasPostfixModifier = Boolean(maybePostfixModifierPosition);
    if (!classGroupId) {
      if (!maybePostfixModifierPosition) {
        return {
          isTailwindClass: false,
          originalClassName
        };
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        return {
          isTailwindClass: false,
          originalClassName
        };
      }
      hasPostfixModifier = false;
    }
    var variantModifier = sortModifiers(modifiers).join(":");
    var modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    return {
      isTailwindClass: true,
      modifierId,
      classGroupId,
      originalClassName,
      hasPostfixModifier
    };
  }).reverse().filter(function(parsed) {
    if (!parsed.isTailwindClass) {
      return true;
    }
    var modifierId = parsed.modifierId, classGroupId = parsed.classGroupId, hasPostfixModifier = parsed.hasPostfixModifier;
    var classId = modifierId + classGroupId;
    if (classGroupsInConflict.has(classId)) {
      return false;
    }
    classGroupsInConflict.add(classId);
    getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach(function(group) {
      return classGroupsInConflict.add(modifierId + group);
    });
    return true;
  }).reverse().map(function(parsed) {
    return parsed.originalClassName;
  }).join(" ");
}

// ../../node_modules/tailwind-merge/dist/lib/create-tailwind-merge.mjs
function createTailwindMerge() {
  for (var _len = arguments.length, createConfig = new Array(_len), _key = 0; _key < _len; _key++) {
    createConfig[_key] = arguments[_key];
  }
  var configUtils;
  var cacheGet;
  var cacheSet;
  var functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    var firstCreateConfig = createConfig[0], restCreateConfig = createConfig.slice(1);
    var config = restCreateConfig.reduce(function(previousConfig, createConfigCurrent) {
      return createConfigCurrent(previousConfig);
    }, firstCreateConfig());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    var cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    var result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}

// ../../node_modules/tailwind-merge/dist/lib/from-theme.mjs
function fromTheme(key) {
  var themeGetter = function themeGetter2(theme) {
    return theme[key] || [];
  };
  themeGetter.isThemeGetter = true;
  return themeGetter;
}

// ../../node_modules/tailwind-merge/dist/lib/validators.mjs
var arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
var fractionRegex = /^\d+\/\d+$/;
var stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]);
var tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
var shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function isLength(value) {
  return isNumber(value) || stringLengths.has(value) || fractionRegex.test(value) || isArbitraryLength(value);
}
function isArbitraryLength(value) {
  return getIsArbitraryValue(value, "length", isLengthOnly);
}
function isArbitrarySize(value) {
  return getIsArbitraryValue(value, "size", isNever);
}
function isArbitraryPosition(value) {
  return getIsArbitraryValue(value, "position", isNever);
}
function isArbitraryUrl(value) {
  return getIsArbitraryValue(value, "url", isUrl);
}
function isArbitraryNumber(value) {
  return getIsArbitraryValue(value, "number", isNumber);
}
function isNumber(value) {
  return !Number.isNaN(Number(value));
}
function isPercent(value) {
  return value.endsWith("%") && isNumber(value.slice(0, -1));
}
function isInteger(value) {
  return isIntegerOnly(value) || getIsArbitraryValue(value, "number", isIntegerOnly);
}
function isArbitraryValue(value) {
  return arbitraryValueRegex.test(value);
}
function isAny() {
  return true;
}
function isTshirtSize(value) {
  return tshirtUnitRegex.test(value);
}
function isArbitraryShadow(value) {
  return getIsArbitraryValue(value, "", isShadow);
}
function getIsArbitraryValue(value, label, testValue) {
  var result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return result[1] === label;
    }
    return testValue(result[2]);
  }
  return false;
}
function isLengthOnly(value) {
  return lengthUnitRegex.test(value);
}
function isNever() {
  return false;
}
function isUrl(value) {
  return value.startsWith("url(");
}
function isIntegerOnly(value) {
  return Number.isInteger(Number(value));
}
function isShadow(value) {
  return shadowRegex.test(value);
}

// ../../node_modules/tailwind-merge/dist/lib/default-config.mjs
function getDefaultConfig() {
  var colors = fromTheme("colors");
  var spacing = fromTheme("spacing");
  var blur = fromTheme("blur");
  var brightness = fromTheme("brightness");
  var borderColor = fromTheme("borderColor");
  var borderRadius = fromTheme("borderRadius");
  var borderSpacing = fromTheme("borderSpacing");
  var borderWidth = fromTheme("borderWidth");
  var contrast = fromTheme("contrast");
  var grayscale = fromTheme("grayscale");
  var hueRotate = fromTheme("hueRotate");
  var invert = fromTheme("invert");
  var gap = fromTheme("gap");
  var gradientColorStops = fromTheme("gradientColorStops");
  var gradientColorStopPositions = fromTheme("gradientColorStopPositions");
  var inset = fromTheme("inset");
  var margin = fromTheme("margin");
  var opacity = fromTheme("opacity");
  var padding = fromTheme("padding");
  var saturate = fromTheme("saturate");
  var scale = fromTheme("scale");
  var sepia = fromTheme("sepia");
  var skew = fromTheme("skew");
  var space = fromTheme("space");
  var translate = fromTheme("translate");
  var getOverscroll = function getOverscroll2() {
    return ["auto", "contain", "none"];
  };
  var getOverflow = function getOverflow2() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  };
  var getSpacingWithAutoAndArbitrary = function getSpacingWithAutoAndArbitrary2() {
    return ["auto", isArbitraryValue, spacing];
  };
  var getSpacingWithArbitrary = function getSpacingWithArbitrary2() {
    return [isArbitraryValue, spacing];
  };
  var getLengthWithEmpty = function getLengthWithEmpty2() {
    return ["", isLength];
  };
  var getNumberWithAutoAndArbitrary = function getNumberWithAutoAndArbitrary2() {
    return ["auto", isNumber, isArbitraryValue];
  };
  var getPositions = function getPositions2() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  };
  var getLineStyles = function getLineStyles2() {
    return ["solid", "dashed", "dotted", "double", "none"];
  };
  var getBlendModes = function getBlendModes2() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  };
  var getAlign = function getAlign2() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  };
  var getZeroAndEmpty = function getZeroAndEmpty2() {
    return ["", "0", isArbitraryValue];
  };
  var getBreaks = function getBreaks2() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  };
  var getNumber = function getNumber2() {
    return [isNumber, isArbitraryNumber];
  };
  var getNumberAndArbitrary = function getNumberAndArbitrary2() {
    return [isNumber, isArbitraryValue];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [isAny],
      spacing: [isLength],
      blur: ["none", "", isTshirtSize, isArbitraryValue],
      brightness: getNumber(),
      borderColor: [colors],
      borderRadius: ["none", "", "full", isTshirtSize, isArbitraryValue],
      borderSpacing: getSpacingWithArbitrary(),
      borderWidth: getLengthWithEmpty(),
      contrast: getNumber(),
      grayscale: getZeroAndEmpty(),
      hueRotate: getNumberAndArbitrary(),
      invert: getZeroAndEmpty(),
      gap: getSpacingWithArbitrary(),
      gradientColorStops: [colors],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: getSpacingWithAutoAndArbitrary(),
      margin: getSpacingWithAutoAndArbitrary(),
      opacity: getNumber(),
      padding: getSpacingWithArbitrary(),
      saturate: getNumber(),
      scale: getNumber(),
      sepia: getZeroAndEmpty(),
      skew: getNumberAndArbitrary(),
      space: getSpacingWithArbitrary(),
      translate: getSpacingWithArbitrary()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": getBreaks()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": getBreaks()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      "float": [{
        "float": ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(getPositions(), [isArbitraryValue])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: getOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": getOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": getOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: getOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": getOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": getOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [inset]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [inset]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [inset]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [inset]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [inset]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [inset]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [inset]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [inset]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [inset]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", isInteger]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: getSpacingWithAutoAndArbitrary()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: getZeroAndEmpty()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: getZeroAndEmpty()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", isInteger]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", isInteger]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [gap]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [gap]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [gap]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(getAlign())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(getAlign(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(getAlign(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [padding]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [padding]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [padding]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [padding]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [padding]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [padding]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [padding]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [padding]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [padding]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [margin]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [margin]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [margin]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [margin]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [margin]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [margin]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [margin]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [margin]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [margin]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [space]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [space]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", isArbitraryValue, spacing]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", isArbitraryValue, isLength]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize]
        }, isTshirtSize, isArbitraryValue]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [isArbitraryValue, spacing, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", isArbitraryValue, isLength]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [isArbitraryValue, spacing, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isArbitraryValue, isLength]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [colors]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [opacity]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [colors]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [opacity]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(getLineStyles(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", isArbitraryValue, isLength]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [colors]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: getSpacingWithArbitrary()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      "break": [{
        "break": ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [opacity]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(getPositions(), [isArbitraryPosition])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryUrl]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [colors]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [gradientColorStops]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [borderRadius]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [borderRadius]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [borderRadius]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [borderRadius]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [borderRadius]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [borderRadius]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [borderRadius]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [borderRadius]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [borderRadius]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [borderRadius]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [borderRadius]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [borderRadius]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [borderRadius]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [borderRadius]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [borderRadius]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [borderWidth]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [borderWidth]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [borderWidth]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [borderWidth]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [borderWidth]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [borderWidth]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [borderWidth]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [borderWidth]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [borderWidth]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [opacity]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(getLineStyles(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [borderWidth]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [borderWidth]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [opacity]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: getLineStyles()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [borderColor]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [borderColor]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [borderColor]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [borderColor]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [borderColor]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [borderColor]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [borderColor]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [borderColor]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(getLineStyles())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isArbitraryValue, isLength]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [isLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [colors]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: getLengthWithEmpty()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [colors]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [opacity]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [isLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [colors]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [opacity]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": getBlendModes()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": getBlendModes()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [blur]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [brightness]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [contrast]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [grayscale]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [hueRotate]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [invert]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [saturate]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [sepia]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [blur]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [brightness]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [contrast]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [grayscale]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [hueRotate]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [invert]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [opacity]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [saturate]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [sepia]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [borderSpacing]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [borderSpacing]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [borderSpacing]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: getNumberAndArbitrary()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: getNumberAndArbitrary()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [scale]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [scale]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [scale]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [translate]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [translate]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [skew]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [skew]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", colors]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [colors]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [colors, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [colors, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}

// ../../node_modules/tailwind-merge/dist/lib/merge-configs.mjs
function mergeConfigs(baseConfig, configExtension) {
  for (var key in configExtension) {
    mergePropertyRecursively(baseConfig, key, configExtension[key]);
  }
  return baseConfig;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
var overrideTypes = /* @__PURE__ */ new Set(["string", "number", "boolean"]);
function mergePropertyRecursively(baseObject, mergeKey, mergeValue) {
  if (!hasOwnProperty.call(baseObject, mergeKey) || overrideTypes.has(typeof mergeValue) || mergeValue === null) {
    baseObject[mergeKey] = mergeValue;
    return;
  }
  if (Array.isArray(mergeValue) && Array.isArray(baseObject[mergeKey])) {
    baseObject[mergeKey] = baseObject[mergeKey].concat(mergeValue);
    return;
  }
  if (typeof mergeValue === "object" && typeof baseObject[mergeKey] === "object") {
    if (baseObject[mergeKey] === null) {
      baseObject[mergeKey] = mergeValue;
      return;
    }
    for (var nextKey in mergeValue) {
      mergePropertyRecursively(baseObject[mergeKey], nextKey, mergeValue[nextKey]);
    }
  }
}

// ../../node_modules/tailwind-merge/dist/lib/extend-tailwind-merge.mjs
function extendTailwindMerge(configExtension) {
  for (var _len = arguments.length, createConfig = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    createConfig[_key - 1] = arguments[_key];
  }
  return typeof configExtension === "function" ? createTailwindMerge.apply(void 0, [getDefaultConfig, configExtension].concat(createConfig)) : createTailwindMerge.apply(void 0, [function() {
    return mergeConfigs(getDefaultConfig(), configExtension);
  }].concat(createConfig));
}

// ../../node_modules/tailwind-merge/dist/lib/tw-merge.mjs
var twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);

// ../../node_modules/tailwind-variants/dist/index.js
var se = { twMerge: true, twMergeConfig: {}, responsiveVariants: false };
var _ = (s) => s || void 0;
var N = (...s) => _(y(s).filter(Boolean).join(" "));
var q = null;
var M = {};
var F = false;
var w = (...s) => (b$1) => b$1.twMerge ? ((!q || F) && (F = false, q = u(M) ? twMerge : extendTailwindMerge(M)), _(q(N(s)))) : N(s);
var Z = (s, b) => {
  for (let e in b)
    s.hasOwnProperty(e) ? s[e] = N(s[e], b[e]) : s[e] = b[e];
  return s;
};
var ie = (s, b$1) => {
  let { extend: e = null, slots: j = {}, variants: U = {}, compoundVariants: C = [], compoundSlots: V = [], defaultVariants: W = {} } = s, m = __spreadValues(__spreadValues({}, se), b$1), S = e != null && e.base ? N(e.base, s == null ? void 0 : s.base) : s == null ? void 0 : s.base, g$1 = e != null && e.variants && !u(e.variants) ? p(U, e.variants) : U, A = e != null && e.defaultVariants && !u(e.defaultVariants) ? __spreadValues(__spreadValues({}, e.defaultVariants), W) : W;
  !u(m.twMergeConfig) && !x(m.twMergeConfig, M) && (F = true, M = m.twMergeConfig);
  let O = u(e == null ? void 0 : e.slots), $ = u(j) ? {} : __spreadValues({ base: N(s == null ? void 0 : s.base, O && (e == null ? void 0 : e.base)) }, j), h$1 = O ? $ : Z(__spreadValues({}, e == null ? void 0 : e.slots), u($) ? { base: s == null ? void 0 : s.base } : $), v = (l2) => {
    if (u(g$1) && u(j) && O)
      return w(S, l2 == null ? void 0 : l2.class, l2 == null ? void 0 : l2.className)(m);
    if (C && !Array.isArray(C))
      throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof C}`);
    if (V && !Array.isArray(V))
      throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof V}`);
    let K = (t, n, a2 = [], i2) => {
      let r = a2;
      if (typeof n == "string")
        r = r.concat(g(n).split(" ").map((c) => `${t}:${c}`));
      else if (Array.isArray(n))
        r = r.concat(n.reduce((c, f) => c.concat(`${t}:${f}`), []));
      else if (typeof n == "object" && typeof i2 == "string") {
        for (let c in n)
          if (n.hasOwnProperty(c) && c === i2) {
            let f = n[c];
            if (f && typeof f == "string") {
              let o = g(f);
              r[i2] ? r[i2] = r[i2].concat(o.split(" ").map((u2) => `${t}:${u2}`)) : r[i2] = o.split(" ").map((u2) => `${t}:${u2}`);
            } else
              Array.isArray(f) && f.length > 0 && (r[i2] = f.reduce((o, u2) => o.concat(`${t}:${u2}`), []));
          }
      }
      return r;
    }, z = (t, n = g$1, a$1 = null, i2 = null) => {
      var J;
      let r = n[t];
      if (!r || u(r))
        return null;
      let c = (J = i2 == null ? void 0 : i2[t]) != null ? J : l2 == null ? void 0 : l2[t];
      if (c === null)
        return null;
      let f = l(c), o = Array.isArray(m.responsiveVariants) && m.responsiveVariants.length > 0 || m.responsiveVariants === true, u2 = A == null ? void 0 : A[t], d = [];
      if (typeof f == "object" && o)
        for (let [k, L] of Object.entries(f)) {
          let ae = r[L];
          if (k === "initial") {
            u2 = L;
            continue;
          }
          Array.isArray(m.responsiveVariants) && !m.responsiveVariants.includes(k) || (d = K(k, ae, d, a$1));
        }
      let T = r[f] || r[l(u2)];
      return typeof d == "object" && typeof a$1 == "string" && d[a$1] ? Z(d, T) : d.length > 0 ? (d.push(T), d) : T;
    }, P = () => g$1 ? Object.keys(g$1).map((t) => z(t, g$1)) : null, p2 = (t, n) => {
      if (!g$1 || typeof g$1 != "object")
        return null;
      let a2 = new Array();
      for (let i2 in g$1) {
        let r = z(i2, g$1, t, n), c = t === "base" && typeof r == "string" ? r : r && r[t];
        c && (a2[a2.length] = c);
      }
      return a2;
    }, D = {};
    for (let t in l2)
      l2[t] !== void 0 && (D[t] = l2[t]);
    let G = (t, n) => {
      var i2;
      let a2 = typeof (l2 == null ? void 0 : l2[t]) == "object" ? { [t]: (i2 = l2[t]) == null ? void 0 : i2.initial } : {};
      return __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, A), D), a2), n);
    }, H = (t = [], n) => {
      let a2 = [];
      for (let _a of t) {
        let _b = _a, { class: i2, className: r } = _b, c = __objRest(_b, ["class", "className"]);
        let f = true;
        for (let [o, u2] of Object.entries(c)) {
          let d = G(o, n);
          if (Array.isArray(u2)) {
            if (!u2.includes(d[o])) {
              f = false;
              break;
            }
          } else if (d[o] !== u2) {
            f = false;
            break;
          }
        }
        f && (i2 && a2.push(i2), r && a2.push(r));
      }
      return a2;
    }, I = (t) => {
      let n = H(C, t), a2 = H(e == null ? void 0 : e.compoundVariants, t);
      return a(a2, n);
    }, ee = (t) => {
      let n = I(t);
      if (!Array.isArray(n))
        return n;
      let a2 = {};
      for (let i2 of n)
        if (typeof i2 == "string" && (a2.base = w(a2.base, i2)(m)), typeof i2 == "object")
          for (let [r, c] of Object.entries(i2))
            a2[r] = w(a2[r], c)(m);
      return a2;
    }, te = (t) => {
      if (V.length < 1)
        return null;
      let n = {};
      for (let _a of V) {
        let _b = _a, { slots: a2 = [], class: i2, className: r } = _b, c = __objRest(_b, ["slots", "class", "className"]);
        if (!u(c)) {
          let f = true;
          for (let o of Object.keys(c)) {
            let u2 = G(o, t)[o];
            if (u2 === void 0 || (Array.isArray(c[o]) ? !c[o].includes(u2) : c[o] !== u2)) {
              f = false;
              break;
            }
          }
          if (!f)
            continue;
        }
        for (let f of a2)
          n[f] = n[f] || [], n[f].push([i2, r]);
      }
      return n;
    };
    if (!u(j) || !O) {
      let t = {};
      if (typeof h$1 == "object" && !u(h$1))
        for (let n of Object.keys(h$1))
          t[n] = (a2) => {
            var i2, r;
            return w(h$1[n], p2(n, a2), ((i2 = ee(a2)) != null ? i2 : [])[n], ((r = te(a2)) != null ? r : [])[n], a2 == null ? void 0 : a2.class, a2 == null ? void 0 : a2.className)(m);
          };
      return t;
    }
    return w(S, P(), I(), l2 == null ? void 0 : l2.class, l2 == null ? void 0 : l2.className)(m);
  }, x2 = () => {
    if (!(!g$1 || typeof g$1 != "object"))
      return Object.keys(g$1);
  };
  return v.variantKeys = x2(), v.extend = e, v.base = S, v.slots = h$1, v.variants = g$1, v.defaultVariants = A, v.compoundSlots = V, v.compoundVariants = C, v;
};

// src/Sidebar/Logo/styles.ts
var StyledSidebarLogo = ie({
  base: "org-min-h-[85px] org-max-h-[85px] org-p-6 [&>img]:org-w-[113px] data-[expanded=false]:org-w-[60px] data-[expanded=false]:org-px-3 [&>img]:data-[expanded=false]:org-w-[40px] org-transition-all org-duration-300"
});

// src/Sidebar/Logo/index.tsx
import { jsx } from "react/jsx-runtime";
var SidebarLogo = forwardRef(
  (_a, ref) => {
    var _b = _a, { expanded = true, onClick, className } = _b, rest = __objRest(_b, ["expanded", "onClick", "className"]);
    const componentRef = useRef(null);
    useImperativeHandle(ref, () => componentRef.current);
    return /* @__PURE__ */ jsx(
      "button",
      __spreadProps(__spreadValues({
        onClick,
        className: StyledSidebarLogo({ className }),
        "data-expanded": expanded,
        ref: componentRef
      }, rest), {
        children: /* @__PURE__ */ jsx("img", { src: rest.src, alt: rest.alt })
      })
    );
  }
);
SidebarLogo.displayName = "Sidebar.Logo";

// src/Sidebar/Root/index.tsx
import {
  forwardRef as forwardRef2,
  useImperativeHandle as useImperativeHandle2,
  useRef as useRef2
} from "react";

// src/Sidebar/Root/styles.ts
var StyledSidebarRoot = ie({
  base: "org-group/sidebar !org-bg-white-0 org-group org-relative org-h-screen org-flex org-flex-col org-gap-4 org-border-r org-border-r-gray-100 org-transition-all org-duration-500"
});

// src/Sidebar/Root/index.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var SidebarRoot = forwardRef2(
  (_a, ref) => {
    var _b = _a, { className, children, expanded = true, maxWidth = "230px" } = _b, rest = __objRest(_b, ["className", "children", "expanded", "maxWidth"]);
    const componentRef = useRef2(null);
    useImperativeHandle2(ref, () => componentRef.current);
    return /* @__PURE__ */ jsx2(
      "div",
      __spreadProps(__spreadValues({}, rest), {
        className: StyledSidebarRoot({ className }),
        style: { width: expanded ? maxWidth : "60px" },
        "data-expanded": expanded,
        ref: componentRef,
        children
      })
    );
  }
);
SidebarRoot.displayName = "Sidebar.Root";

// src/Sidebar/Trigger/index.tsx
import { ArrowRight } from "lucide-react";

// src/Sidebar/Trigger/styles.ts
var StyledSidebarTrigger = ie({
  base: "org-opacity-0 org-z-50 org-bg-blue-300 org-rounded-full org-p-1 org-absolute org-top-[73px] org-right-[-15px] hover:org-bg-blue-400 focus-visible:org-opacity-100 data-[expanded=true]:org-rotate-180 org-transition-all org-duration-300 group-hover:org-opacity-100"
});

// src/Sidebar/Trigger/index.tsx
import {
  forwardRef as forwardRef3,
  useImperativeHandle as useImperativeHandle3,
  useRef as useRef3
} from "react";
import { jsx as jsx3 } from "react/jsx-runtime";
var SidebarTrigger = forwardRef3((_a, ref) => {
  var _b = _a, { expanded = true, className } = _b, rest = __objRest(_b, ["expanded", "className"]);
  const componentRef = useRef3(null);
  useImperativeHandle3(ref, () => componentRef.current);
  return /* @__PURE__ */ jsx3(
    "button",
    __spreadProps(__spreadValues({
      className: StyledSidebarTrigger({ className })
    }, rest), {
      "data-expanded": expanded,
      children: /* @__PURE__ */ jsx3(ArrowRight, { size: 20, color: "white" })
    })
  );
});
SidebarTrigger.displayName = "Sidebar.Trigger";

// src/Sidebar/index.tsx
import { forwardRef as forwardRef5 } from "react";

// src/Sidebar/NavItem/index.tsx
import { Nav, Tooltip } from "@77sol-ui/molecules";
import { forwardRef as forwardRef4 } from "react";
import { jsx as jsx4, jsxs } from "react/jsx-runtime";
var SidebarNavItem = forwardRef4(
  (_a, ref) => {
    var _b = _a, {
      children,
      tooltipLabel = "",
      expanded = false,
      sideOffset = 15,
      asChild
    } = _b, props = __objRest(_b, [
      "children",
      "tooltipLabel",
      "expanded",
      "sideOffset",
      "asChild"
    ]);
    if (expanded || !tooltipLabel) {
      return /* @__PURE__ */ jsx4(Nav.Item, __spreadProps(__spreadValues({}, props), { asChild, ref, children }));
    }
    return /* @__PURE__ */ jsx4(Tooltip.Provider, { delayDuration: 50, children: /* @__PURE__ */ jsxs(Tooltip.Root, { children: [
      /* @__PURE__ */ jsx4(Tooltip.Trigger, { asChild: true, children: /* @__PURE__ */ jsx4(Nav.Item, __spreadProps(__spreadValues({}, props), { ref, asChild, children })) }),
      /* @__PURE__ */ jsx4(Tooltip.Portal, { children: /* @__PURE__ */ jsx4(Tooltip.Content, { side: "right", sideOffset, children: tooltipLabel }) })
    ] }) });
  }
);
SidebarNavItem.displayName = "Sidebar.NavItem";

// src/Sidebar/Content/styles.ts
var StyledSidebarContent = ie({
  base: "org-h-full org-overflow-y-auto org-overflow-x-hidden"
});

// src/Sidebar/Content/index.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
function SidebarContent(_a) {
  var _b = _a, {
    className,
    children
  } = _b, rest = __objRest(_b, [
    "className",
    "children"
  ]);
  return /* @__PURE__ */ jsx5(
    "div",
    __spreadProps(__spreadValues({}, rest), {
      className: `${StyledSidebarContent({ className })} sidebar-scroll`,
      children
    })
  );
}
SidebarContent.displayName = "Sidebar.Content";

// src/Sidebar/index.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var NavRoot = forwardRef5((_a, ref) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx6(Nav2.Root, __spreadProps(__spreadValues({}, props), { ref, children }));
});
NavRoot.displayName = "Sidebar.NavRoot";
var NavIcon = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx6(Nav2.Icon, __spreadProps(__spreadValues({}, props), { children }));
};
NavIcon.displayName = "Sidebar.NavIcon";
var NavTitle = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx6(Nav2.Title, __spreadProps(__spreadValues({}, props), { children }));
};
NavTitle.displayName = "Sidebar.NavTitle";
var Marker = forwardRef5(
  (_a, ref) => {
    var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
    return /* @__PURE__ */ jsx6(Nav2.Marker, __spreadProps(__spreadValues({}, props), { ref }));
  }
);
Marker.displayName = "Sidebar.Marker";
var Trigger = forwardRef5((_a, ref) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx6(SidebarTrigger, __spreadProps(__spreadValues({}, props), { ref, children }));
});
Trigger.displayName = "Sidebar.Trigger";
var Sidebar = {
  Root: SidebarRoot,
  Logo: SidebarLogo,
  Content: SidebarContent,
  Trigger,
  NavRoot,
  NavItem: SidebarNavItem,
  NavIcon,
  NavTitle,
  Marker
};

// src/Header/Root/styles.ts
var StyledHeaderRoot = ie({
  base: "org-bg-white-0 org-sticky org-w-full org-top-0 org-z-[1] org-h-[78px] xl:org-h-[88px] org-p-4 org-border org-border-gray-100 org-flex org-items-center org-justify-between"
});

// src/Header/Root/index.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
function Root(_a) {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx7("header", __spreadProps(__spreadValues({ className: StyledHeaderRoot({ className }) }, props), { children }));
}
Root.displayName = "Header.Root";

// src/Header/Content/styles.ts
var StyledHeaderContent = ie({
  base: "org-h-full org-flex org-items-center org-gap-1 md:org-gap-2",
  variants: {
    align: {
      start: "org-mr-auto",
      center: "org-mx-auto",
      end: "org-ml-auto"
    }
  }
});

// src/Header/Content/index.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
function Content(_a) {
  var _b = _a, {
    children,
    align,
    className
  } = _b, props = __objRest(_b, [
    "children",
    "align",
    "className"
  ]);
  return /* @__PURE__ */ jsx8("div", __spreadProps(__spreadValues({ className: StyledHeaderContent({ align, className }) }, props), { children }));
}
Content.displayName = "Header.Content";

// src/Header/Logo/styles.ts
var StyledHeaderLogo = ie({
  base: "org-w-[80px] org-max-h-[85px] md:org-w-[125px]"
});

// src/Header/Logo/index.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
function Logo(_a) {
  var _b = _a, {
    expanded = true,
    onClick,
    className
  } = _b, rest = __objRest(_b, [
    "expanded",
    "onClick",
    "className"
  ]);
  return /* @__PURE__ */ jsx9(
    "button",
    __spreadProps(__spreadValues({
      onClick,
      className: StyledHeaderLogo({ className })
    }, rest), {
      children: /* @__PURE__ */ jsx9("img", { src: rest.src, alt: rest.alt })
    })
  );
}
Logo.displayName = "Header.Logo";

// src/Header/index.tsx
import {
  DropdownMenu,
  Button as AtomButton
} from "@77sol-ui/atoms";
import { forwardRef as forwardRef6 } from "react";
import { jsx as jsx10 } from "react/jsx-runtime";
var DropdownRoot = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx10(DropdownMenu.Root, __spreadProps(__spreadValues({}, props), { children }));
};
DropdownRoot.displayName = "Header.DropdownMenuRoot";
var DropdownTrigger = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx10(DropdownMenu.Trigger, __spreadProps(__spreadValues({}, props), { children }));
};
DropdownTrigger.displayName = "Header.DropdownTrigger";
var DropdownItem = forwardRef6(
  (_a, ref) => {
    var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
    return /* @__PURE__ */ jsx10(
      DropdownMenu.Item,
      __spreadProps(__spreadValues({}, props), {
        ref,
        className: `${className} org-font-sans`,
        children
      })
    );
  }
);
DropdownItem.displayName = "Header.DropdownItem";
var DropdownContent = (_a) => {
  var _b = _a, {
    children,
    className
  } = _b, props = __objRest(_b, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ jsx10(
    DropdownMenu.Content,
    __spreadProps(__spreadValues({}, props), {
      className: `${className} org-z-10 org-font-sans org-text-sm`,
      children
    })
  );
};
DropdownContent.displayName = "Header.DropdownContent";
var Button = (_a) => {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx10(AtomButton, __spreadProps(__spreadValues({}, props), { className: `${className} org-text-sm`, children }));
};
Button.displayName = "Header.Button";
var Header = {
  Root,
  Content,
  Logo,
  DropdownRoot,
  DropdownTrigger,
  DropdownItem,
  DropdownContent,
  Button
};

// src/SidebarMobile/index.tsx
import {
  Nav as Nav3,
  SlideMenu,
  Accordion
} from "@77sol-ui/molecules";

// src/SidebarMobile/Separator/styles.ts
var StyledSidebarMobileSeparator = ie({
  base: "org-bg-gray-100 org-w-[95%] org-mt-0 [&:nth-last-child(2)]:org-mt-auto org-mx-auto org-mb-0"
});

// src/SidebarMobile/Separator/index.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
function SidebarMobileSeparator(_a) {
  var rest = __objRest(_a, []);
  return /* @__PURE__ */ jsx11("hr", __spreadValues({ className: StyledSidebarMobileSeparator() }, rest));
}
SidebarMobileSeparator.displayName = "SidebarMobile.Separator";

// src/SidebarMobile/Logout/index.tsx
import {
  forwardRef as forwardRef7
} from "react";

// src/SidebarMobile/Logout/styles.ts
var StyledSidebarMobileLogout = ie({
  base: "org-w-full org-text-red-300 org-flex org-items-center org-px-6 org-py-3.5 org-cursor-pointer org-gap-2 [&>svg]:org-w-4 hover:org-bg-red-50"
});

// src/SidebarMobile/Logout/index.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var SidebarMobileLogout = forwardRef7((_a, ref) => {
  var _b = _a, { className, children } = _b, rest = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsx12(
    "button",
    __spreadProps(__spreadValues({
      className: StyledSidebarMobileLogout({ className })
    }, rest), {
      ref,
      children
    })
  );
});
SidebarMobileLogout.displayName = "SidebarMobile.Logout";

// src/SidebarMobile/Logo/styles.ts
var StyledSidebarMobileLogo = ie({
  base: "org-w-full org-mb-4 org-px-3 [&>img]:org-max-w-[100px]"
});

// src/SidebarMobile/Logo/index.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
function SidebarMobileLogo(_a) {
  var _b = _a, {
    expanded = true,
    onClick,
    className
  } = _b, rest = __objRest(_b, [
    "expanded",
    "onClick",
    "className"
  ]);
  return /* @__PURE__ */ jsx13(
    "button",
    __spreadProps(__spreadValues({
      onClick,
      className: StyledSidebarMobileLogo({ className }),
      "data-expanded": expanded
    }, rest), {
      children: /* @__PURE__ */ jsx13("img", { src: rest.src, alt: rest.alt })
    })
  );
}
SidebarMobileLogo.displayName = "Sidebar.Logo";

// src/SidebarMobile/Profile/Avatar/index.tsx
import { useState } from "react";

// src/SidebarMobile/Profile/Avatar/styles.ts
var StyledSidebarMobileProfileAvatar = ie({
  base: "org-rounded-full org-w-14 org-h-14"
});
var StyledSidebarMobileProfilePreview = ie({
  base: "org-rounded-full org-w-14 org-h-14 org-flex org-items-center org-justify-center org-bg-gray-100 [&>svg]:org-text-gray-300"
});

// src/SidebarMobile/Profile/Avatar/index.tsx
import { User2 } from "lucide-react";
import { jsx as jsx14, jsxs as jsxs2 } from "react/jsx-runtime";
function SidebarMobileProfileAvatar(_a) {
  var _b = _a, {
    className,
    src,
    alt
  } = _b, rest = __objRest(_b, [
    "className",
    "src",
    "alt"
  ]);
  const [isLoaded, setIsLoaded] = useState(false);
  return /* @__PURE__ */ jsxs2("div", { children: [
    !isLoaded && /* @__PURE__ */ jsx14(
      "div",
      {
        className: StyledSidebarMobileProfilePreview(),
        "data-testid": "profileAvatarPreview",
        children: /* @__PURE__ */ jsx14(User2, { strokeWidth: 1.5 })
      }
    ),
    /* @__PURE__ */ jsx14(
      "img",
      __spreadValues({
        className: StyledSidebarMobileProfileAvatar({ className }),
        alt,
        src,
        style: { display: isLoaded ? "block" : "none " },
        onLoad: () => setIsLoaded(true)
      }, rest)
    )
  ] });
}
SidebarMobileProfileAvatar.displayName = "SidebarMobile.ProfileAvatar";

// src/SidebarMobile/Profile/Content/styles.ts
var StyledProfileContent = ie({
  base: "org-flex org-flex-col org-gap-2"
});

// src/SidebarMobile/Profile/Content/index.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
function ProfileContent(_a) {
  var _b = _a, {
    children,
    className
  } = _b, rest = __objRest(_b, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ jsx15("div", __spreadProps(__spreadValues({ className: StyledProfileContent({ className }) }, rest), { children }));
}
ProfileContent.displayName = "SidebarMobile.ProfileContent";

// src/SidebarMobile/Profile/Root/styles.ts
var StyledProfileRoot = ie({
  base: "org-w-full org-flex org-p-4 org-items-center org-justify-between [&>svg]:org-w-6 [&>svg]:org-text-gray-600"
});

// src/SidebarMobile/Profile/Root/index.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
function ProfileRoot(_a) {
  var _b = _a, {
    children,
    className
  } = _b, rest = __objRest(_b, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ jsx16("div", __spreadProps(__spreadValues({ className: StyledProfileRoot({ className }) }, rest), { children }));
}
ProfileRoot.displayName = "SidebarMobile.ProfileRoot";

// src/SidebarMobile/Profile/Subtitle/styles.ts
var StyledProfileSubtitle = ie({
  base: "org-font-sans org-font-normal org-text-xs org-leading-3 org-text-gray-300"
});

// src/SidebarMobile/Profile/Subtitle/index.tsx
import { jsx as jsx17 } from "react/jsx-runtime";
function ProfileSubitle(_a) {
  var _b = _a, {
    children,
    className
  } = _b, rest = __objRest(_b, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ jsx17("h1", __spreadProps(__spreadValues({ className: StyledProfileSubtitle({ className }) }, rest), { children }));
}
ProfileSubitle.displayName = "SidebarMobile.ProfileSubitle";

// src/SidebarMobile/Profile/Title/styles.ts
var StyledProfileTitle = ie({
  base: "org-font-sans org-font-medium org-text-sm org-leading-4 org-text-[#1D1E20]"
});

// src/SidebarMobile/Profile/Title/index.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
function ProfileTitle(_a) {
  var _b = _a, {
    children,
    className
  } = _b, rest = __objRest(_b, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ jsx18("h1", __spreadProps(__spreadValues({ className: StyledProfileTitle({ className }) }, rest), { children }));
}
ProfileTitle.displayName = "SidebarMobile.ProfileTitle";

// src/SidebarMobile/Profile/Wrapper/styles.ts
var StyledProfileWrapper = ie({
  base: "org-w-full org-flex org-items-center org-gap-3"
});

// src/SidebarMobile/Profile/Wrapper/index.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
function ProfileWrapper(_a) {
  var _b = _a, {
    children,
    className
  } = _b, rest = __objRest(_b, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ jsx19("div", __spreadProps(__spreadValues({ className: StyledProfileWrapper({ className }) }, rest), { children }));
}
ProfileWrapper.displayName = "SidebarMobile.ProfileWrapper";

// src/SidebarMobile/Profile/index.tsx
var Profile = {
  Root: ProfileRoot,
  Wrapper: ProfileWrapper,
  Content: ProfileContent,
  Avatar: SidebarMobileProfileAvatar,
  Title: ProfileTitle,
  Subtitle: ProfileSubitle
};

// src/SidebarMobile/index.tsx
import { forwardRef as forwardRef8 } from "react";
import { jsx as jsx20 } from "react/jsx-runtime";
var SidebarMobileRoot = (_a) => {
  var _b = _a, {
    children
  } = _b, rest = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ jsx20(SlideMenu.Root, __spreadProps(__spreadValues({}, rest), { children }));
};
SidebarMobileRoot.displayName = "SidebarMobile.Root";
var SidebarMobileTrigger = forwardRef8((_a, ref) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx20(SlideMenu.Trigger, __spreadProps(__spreadValues({ ref }, props), { children }));
});
SidebarMobileTrigger.displayName = "SidebarMobile.Trigger";
var SidebarMobilePortal = (_a) => {
  var _b = _a, {
    children
  } = _b, rest = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ jsx20(SlideMenu.Portal, __spreadProps(__spreadValues({}, rest), { children }));
};
SidebarMobilePortal.displayName = "SidebarMobile.Portal";
var SidebarMobileOverlay = forwardRef8((_a, ref) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx20(SlideMenu.Overlay, __spreadProps(__spreadValues({ ref }, props), { children }));
});
SidebarMobileOverlay.displayName = "SidebarMobile.Overlay";
var SidebarMobileWrapper = forwardRef8((_a, ref) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx20(SlideMenu.Wrapper, __spreadProps(__spreadValues({ ref }, props), { children }));
});
SidebarMobileWrapper.displayName = "SidebarMobile.Wrapper";
var SidebarMobileContent = forwardRef8((_a, ref) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx20(SlideMenu.Content, __spreadProps(__spreadValues({ ref }, props), { children }));
});
SidebarMobileContent.displayName = "SidebarMobile.Content";
var SidebarMobileClose = (_a) => {
  var _b = _a, {
    children
  } = _b, rest = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ jsx20(SlideMenu.Close, __spreadProps(__spreadValues({}, rest), { children }));
};
SidebarMobileClose.displayName = "SidebarMobile.Close";
var NavRoot2 = forwardRef8(
  (_a, ref) => {
    var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
    return /* @__PURE__ */ jsx20(Nav3.Root, __spreadProps(__spreadValues({ ref }, props), { children }));
  }
);
NavRoot2.displayName = "SidebarMobile.NavRoot";
var NavItem = forwardRef8(
  (_a, ref) => {
    var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
    return /* @__PURE__ */ jsx20(Nav3.Item, __spreadProps(__spreadValues({ ref }, props), { children }));
  }
);
NavItem.displayName = "SidebarMobile.NavItem";
var NavIcon2 = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ jsx20(Nav3.Icon, __spreadProps(__spreadValues({}, props), { children }));
};
NavIcon2.displayName = "SidebarMobile.NavIcon";
var NavTitle2 = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ jsx20(Nav3.Title, __spreadProps(__spreadValues({}, props), { children }));
};
NavTitle2.displayName = "SidebarMobile.NavTitle";
var Marker2 = forwardRef8(
  (_a, ref) => {
    var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
    return /* @__PURE__ */ jsx20(Nav3.Marker, __spreadProps(__spreadValues({}, props), { ref }));
  }
);
Marker2.displayName = "SidebarMobile.Marker";
var SidebarMobileGroup = forwardRef8((_a, ref) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx20(Accordion.Root, __spreadProps(__spreadValues({ ref }, props), { children }));
});
SidebarMobileGroup.displayName = "SidebarMobile.AccordionGroup";
var SidebarMobileAccordion = forwardRef8((_a, ref) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx20(Accordion.Item, __spreadProps(__spreadValues({ ref }, props), { children }));
});
SidebarMobileAccordion.displayName = "SidebarMobile.Accordion";
var SidebarMobileAccordionTrigger = forwardRef8((_a, ref) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx20(Accordion.Trigger, __spreadProps(__spreadValues({ ref }, props), { children }));
});
SidebarMobileAccordionTrigger.displayName = "SidebarMobile.AccordionTrigger";
var SidebarMobileAccordionContent = forwardRef8((_a, ref) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx20(Accordion.Content, __spreadProps(__spreadValues({ ref }, props), { children }));
});
SidebarMobileAccordionContent.displayName = "SidebarMobile.AccordionContent";
var Logout = forwardRef8(
  (_a, ref) => {
    var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
    return /* @__PURE__ */ jsx20(SidebarMobileLogout, __spreadProps(__spreadValues({ ref }, props), { children }));
  }
);
Logout.displayName = "SidebarMobile.Logout";
var SidebarMobile = {
  Root: SidebarMobileRoot,
  Trigger: SidebarMobileTrigger,
  Portal: SidebarMobilePortal,
  Overlay: SidebarMobileOverlay,
  Wrapper: SidebarMobileWrapper,
  Content: SidebarMobileContent,
  Separator: SidebarMobileSeparator,
  ProfileRoot: Profile.Root,
  ProfileWrapper: Profile.Wrapper,
  ProfileContent: Profile.Content,
  ProfileAvatar: Profile.Avatar,
  ProfileTitle: Profile.Title,
  ProfileSubtitle: Profile.Subtitle,
  Logout,
  Logo: SidebarMobileLogo,
  Close: SidebarMobileClose,
  AccordionGroup: SidebarMobileGroup,
  Accordion: SidebarMobileAccordion,
  AccordionTrigger: SidebarMobileAccordionTrigger,
  AccordionContent: SidebarMobileAccordionContent,
  NavRoot: NavRoot2,
  NavItem,
  NavIcon: NavIcon2,
  NavTitle: NavTitle2,
  Marker: Nav3.Marker
};

// src/Notification/Body/index.tsx
import { forwardRef as forwardRef9 } from "react";

// src/Notification/Body/styles.ts
var StyledBody = ie({
  base: "org-flex-auto org-overflow-auto org-flex org-flex-col"
});

// src/Notification/Body/index.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var Body = forwardRef9((_a, ref) => {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx21(
    "div",
    __spreadProps(__spreadValues({}, props), {
      ref,
      className: StyledBody({
        className: `notification-list-scroll ${className}`
      }),
      children
    })
  );
});
Body.displayName = "Notification.Body";

// src/Notification/Footer/index.tsx
import { forwardRef as forwardRef10 } from "react";

// src/Notification/Footer/styles.ts
var StyledFooter = ie({
  base: "org-flex org-px-6 org-pt-5"
});

// src/Notification/Footer/index.tsx
import { jsx as jsx22 } from "react/jsx-runtime";
var Footer = forwardRef10(
  (_a, ref) => {
    var _b = _a, { children, className, justify = "center" } = _b, props = __objRest(_b, ["children", "className", "justify"]);
    return /* @__PURE__ */ jsx22(
      "div",
      __spreadProps(__spreadValues({}, props), {
        ref,
        className: StyledFooter({ className }),
        style: __spreadProps(__spreadValues({}, props == null ? void 0 : props.style), {
          justifyContent: justify
        }),
        children
      })
    );
  }
);
Footer.displayName = "Notification.Footer";

// src/Notification/Header/index.tsx
import { forwardRef as forwardRef11 } from "react";

// src/Notification/Header/styles.ts
var StyledHeader = ie({
  base: "org-px-6 org-pb-5"
});

// src/Notification/Header/index.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
var Header2 = forwardRef11((_a, ref) => {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx23("div", __spreadProps(__spreadValues({}, props), { ref, className: StyledHeader({ className }), children }));
});
Header2.displayName = "Notification.Header";

// src/Notification/Content/index.tsx
import { forwardRef as forwardRef12 } from "react";

// src/Notification/Content/styles.ts
var StyledContent = ie({
  base: "org-flex org-flex-col org-h-full org-max-w-full org-max-h-full org-bg-white-0"
});

// src/Notification/Content/index.tsx
import { jsx as jsx24 } from "react/jsx-runtime";
var Content2 = forwardRef12((_a, ref) => {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx24("div", __spreadProps(__spreadValues({}, props), { ref, className: StyledContent({ className }), children }));
});
Content2.displayName = "Notification.Content";

// src/Notification/Title/index.tsx
import { forwardRef as forwardRef13 } from "react";

// src/Notification/Title/styles.ts
var StyledTitle = ie({
  base: "org-font-sans org-text-lg org-font-bold org-text-blue-800"
});

// src/Notification/Title/index.tsx
import { jsx as jsx25 } from "react/jsx-runtime";
var Title = forwardRef13((_a, ref) => {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx25("h2", __spreadProps(__spreadValues({}, props), { ref, className: StyledTitle({ className }), children }));
});
Title.displayName = "Notification.Title";

// src/Notification/Item/index.tsx
import { forwardRef as forwardRef14 } from "react";

// src/Notification/Item/styles.ts
var StyledItem = ie({
  base: "org-p-6 org-flex org-gap-4 org-h-fit org-w-full hover:org-bg-gray-50 org-transition-colors org-outline-none focus-visible:org-bg-gray-50",
  variants: {
    highlighted: {
      true: "org-bg-blue-50"
    }
  }
});

// src/Notification/Item/index.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
var Item = forwardRef14(
  (_a, ref) => {
    var _b = _a, { children, className, highlighted = false } = _b, props = __objRest(_b, ["children", "className", "highlighted"]);
    return /* @__PURE__ */ jsx26(
      "button",
      __spreadProps(__spreadValues({}, props), {
        ref,
        className: StyledItem({ className, highlighted }),
        children
      })
    );
  }
);
Item.displayName = "Notification.Item";

// src/Notification/Icon/index.tsx
import { forwardRef as forwardRef15 } from "react";

// src/Notification/Icon/styles.ts
var StyledIcon = ie({
  base: "org-bg-blue-50 org-text-blue-300 org-rounded-full org-p-[9px] org-max-w-[38px] org-max-h-[38px] org-flex org-items-center org-justify-center"
});

// src/Notification/Icon/index.tsx
import { jsx as jsx27 } from "react/jsx-runtime";
var Icon = forwardRef15((_a, ref) => {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx27("div", __spreadProps(__spreadValues({}, props), { ref, className: StyledIcon({ className }), children }));
});
Icon.displayName = "Notification.Icon";

// src/Notification/Text/index.tsx
import { forwardRef as forwardRef16 } from "react";

// src/Notification/Text/styles.ts
var StyledText = ie({
  base: "org-font-sans org-text-sm org-font-medium org-text-blue-800"
});

// src/Notification/Text/index.tsx
import { jsx as jsx28 } from "react/jsx-runtime";
var Text = forwardRef16((_a, ref) => {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx28("h3", __spreadProps(__spreadValues({}, props), { ref, className: StyledText({ className }), children }));
});
Text.displayName = "Notification.Text";

// src/Notification/Description/index.tsx
import { forwardRef as forwardRef17 } from "react";

// src/Notification/Description/styles.ts
var StyledDescription = ie({
  base: "org-font-sans org-text-sm org-font-normal org-text-gray-600"
});

// src/Notification/Description/index.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
var Description = forwardRef17((_a, ref) => {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx29("p", __spreadProps(__spreadValues({}, props), { ref, className: StyledDescription({ className }), children }));
});
Description.displayName = "Notification.Description";

// src/Notification/Message/index.tsx
import { forwardRef as forwardRef18 } from "react";

// src/Notification/Message/styles.ts
var StyledMessage = ie({
  base: "org-flex org-flex-col org-gap-1 org-text-start"
});

// src/Notification/Message/index.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
var Message = forwardRef18((_a, ref) => {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx30("div", __spreadProps(__spreadValues({}, props), { ref, className: StyledMessage({ className }), children }));
});
Message.displayName = "Notification.Message";

// src/Notification/Small/index.tsx
import { forwardRef as forwardRef19 } from "react";

// src/Notification/Small/styles.ts
var StyledSmall = ie({
  base: "org-font-sans org-text-xs org-font-normal org-text-gray-400 org-mt-1"
});

// src/Notification/Small/index.tsx
import { jsx as jsx31 } from "react/jsx-runtime";
var Small = forwardRef19(
  (_a, ref) => {
    var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
    return /* @__PURE__ */ jsx31("small", __spreadProps(__spreadValues({}, props), { ref, className: StyledSmall({ className }), children }));
  }
);
Small.displayName = "Notification.Small";

// src/Notification/Trigger/index.tsx
import { Button as Button2 } from "@77sol-ui/atoms";
import { forwardRef as forwardRef20 } from "react";

// src/Notification/Trigger/styles.ts
var StyledTrigger = ie({
  base: "org-relative org-group"
});

// src/Notification/Trigger/index.tsx
import { jsx as jsx32 } from "react/jsx-runtime";
var Trigger2 = forwardRef20(
  (_a, ref) => {
    var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
    return /* @__PURE__ */ jsx32(Button2, __spreadProps(__spreadValues({}, props), { ref, className: StyledTrigger({ className }), children }));
  }
);
Trigger2.displayName = "Notification.Trigger";

// src/Notification/Popover/index.tsx
import { forwardRef as forwardRef21 } from "react";
import * as RadixPopover from "@radix-ui/react-popover";

// src/Notification/Popover/styles.ts
var StyledPopover = ie({
  base: "org-bg-white-0 org-outline-none org-py-6 org-h-[var(--radix-popover-content-available-height)] org-w-[var(--radix-popover-content-available-width)] org-overflow-hidden org-rounded org-border org-border-gray-100 org-will-change-[transform,opacity] data-[state=open]:data-[side=bottom]:org-animate-slideUpAndFade data-[state=open]:data-[side=left]:org-animate-slideRightAndFade data-[state=open]:data-[side=right]:org-animate-slideLeftAndFade data-[state=open]:data-[side=top]:org-animate-slideDownAndFade"
});

// src/Notification/Popover/index.tsx
import { jsx as jsx33, jsxs as jsxs3 } from "react/jsx-runtime";
var Popover = forwardRef21(
  (_a, ref) => {
    var _b = _a, {
      children,
      maxWidth = "423px",
      maxHeight = "617px",
      zIndex,
      className,
      defaultOpen,
      open,
      onOpenChange,
      modal,
      trigger
    } = _b, props = __objRest(_b, [
      "children",
      "maxWidth",
      "maxHeight",
      "zIndex",
      "className",
      "defaultOpen",
      "open",
      "onOpenChange",
      "modal",
      "trigger"
    ]);
    return /* @__PURE__ */ jsxs3(
      RadixPopover.Root,
      {
        defaultOpen,
        open,
        onOpenChange,
        modal,
        children: [
          trigger && /* @__PURE__ */ jsx33(RadixPopover.Trigger, { asChild: true, children: trigger }),
          /* @__PURE__ */ jsx33(RadixPopover.Portal, { children: /* @__PURE__ */ jsx33(
            RadixPopover.Content,
            __spreadProps(__spreadValues({
              ref,
              className: StyledPopover({ className }),
              style: __spreadProps(__spreadValues({}, props == null ? void 0 : props.style), {
                maxWidth,
                maxHeight,
                zIndex
              })
            }, props), {
              children
            })
          ) })
        ]
      }
    );
  }
);
Popover.displayName = "Notification.Popover";

// src/Notification/Slide/index.tsx
import { Button as Button3 } from "@77sol-ui/atoms";
import {
  SlideMenu as SlideMenu2
} from "@77sol-ui/molecules";
import { ArrowLeft } from "lucide-react";
import { forwardRef as forwardRef22 } from "react";

// src/Notification/Slide/style.tsx
var StyledCloseButton = ie({
  base: "org-ml-6 org-mb-5 org-w-fit !org-text-sm !org-font-normal org-px-2 org-py-1"
});
var StyledWrapper = ie({
  base: "data-[state=open]:data-[direction=ltr]:org-animate-slideOpenLeft data-[state=closed]:data-[direction=ltr]:org-animate-slideCloseLeft data-[state=open]:data-[direction=rtl]:org-animate-slideOpenRight data-[state=closed]:data-[direction=rtl]:org-animate-slideCloseRight org-overflow-x-hidden"
});

// src/Notification/Slide/index.tsx
import { jsx as jsx34, jsxs as jsxs4 } from "react/jsx-runtime";
var Slide = forwardRef22(
  (_a, ref) => {
    var _b = _a, {
      children,
      trigger,
      container,
      zIndex,
      open,
      defaultOpen,
      onOpenChange,
      modal,
      direction = "ltr"
    } = _b, props = __objRest(_b, [
      "children",
      "trigger",
      "container",
      "zIndex",
      "open",
      "defaultOpen",
      "onOpenChange",
      "modal",
      "direction"
    ]);
    return /* @__PURE__ */ jsxs4(
      SlideMenu2.Root,
      {
        open,
        defaultOpen,
        onOpenChange,
        modal,
        children: [
          trigger && /* @__PURE__ */ jsx34(SlideMenu2.Trigger, { asChild: true, children: trigger }),
          /* @__PURE__ */ jsxs4(SlideMenu2.Portal, { container, children: [
            /* @__PURE__ */ jsx34(SlideMenu2.Overlay, {}),
            /* @__PURE__ */ jsxs4(
              SlideMenu2.Wrapper,
              __spreadProps(__spreadValues({}, props), {
                ref,
                direction,
                "data-direction": direction,
                className: StyledWrapper(),
                style: __spreadProps(__spreadValues({}, props == null ? void 0 : props.style), {
                  zIndex
                }),
                children: [
                  /* @__PURE__ */ jsx34(SlideMenu2.Close, { asChild: true, children: /* @__PURE__ */ jsxs4(Button3, { variant: "text", className: StyledCloseButton(), children: [
                    /* @__PURE__ */ jsx34(ArrowLeft, { size: 18 }),
                    /* @__PURE__ */ jsx34("span", { children: "Voltar" })
                  ] }) }),
                  /* @__PURE__ */ jsx34(SlideMenu2.Content, { className: "org-h-full", children })
                ]
              })
            )
          ] })
        ]
      }
    );
  }
);
Slide.displayName = "Notification.Slide";

// src/Notification/Marker/index.tsx
import { forwardRef as forwardRef23 } from "react";

// src/Notification/Marker/styles.ts
var StyledMarker = ie({
  base: "org-absolute org-w-[6px] org-h-[6px] org-bg-red-200 org-rounded-full org-right-[5px] org-top-[1px]",
  variants: {
    animate: {
      true: "org-animate-bounce group-data-[state=open]:org-animate-[unset]"
    }
  }
});

// src/Notification/Marker/index.tsx
import { jsx as jsx35 } from "react/jsx-runtime";
var Marker3 = forwardRef23(
  (_a, ref) => {
    var _b = _a, { className, animate = false } = _b, props = __objRest(_b, ["className", "animate"]);
    return /* @__PURE__ */ jsx35(
      "div",
      __spreadProps(__spreadValues({}, props), {
        ref,
        className: StyledMarker({ className, animate })
      })
    );
  }
);
Marker3.displayName = "Notification.Marker";

// src/Notification/EmptyState/index.tsx
import { forwardRef as forwardRef24 } from "react";

// src/Notification/EmptyState/styles.ts
var StyledWrapper2 = ie({
  base: "org-mx-auto org-flex org-h-full org-max-w-[80%] org-flex-col org-justify-center org-gap-1 org-text-center"
});
var StyledTitle2 = ie({
  base: "org-font-sans org-text-[15px] org-font-semibold org-leading-6 org-text-gray-600"
});
var StyledDescription2 = ie({
  base: "org-font-sans org-text-[13px] org-font-normal org-leading-4 org-text-gray-400"
});

// src/Notification/EmptyState/index.tsx
import { jsx as jsx36, jsxs as jsxs5 } from "react/jsx-runtime";
var EmptyState = forwardRef24(
  (_a, ref) => {
    var _b = _a, { title, description, className } = _b, props = __objRest(_b, ["title", "description", "className"]);
    return /* @__PURE__ */ jsxs5("div", __spreadProps(__spreadValues({}, props), { ref, className: StyledWrapper2({ className }), children: [
      /* @__PURE__ */ jsx36("h4", { className: StyledTitle2(), children: title }),
      /* @__PURE__ */ jsx36("p", { className: StyledDescription2(), children: description })
    ] }));
  }
);
EmptyState.displayName = "Notification.EmptyState";

// src/Notification/Identifier/index.tsx
import { forwardRef as forwardRef25 } from "react";

// src/Notification/Identifier/styles.ts
var StyledIdentifier = ie({
  base: "org-font-sans org-text-xs org-font-medium org-text-blue-300"
});

// src/Notification/Identifier/index.tsx
import { jsx as jsx37 } from "react/jsx-runtime";
var Identifier = forwardRef25((_a, ref) => {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx37("h6", __spreadProps(__spreadValues({}, props), { ref, className: StyledIdentifier({ className }), children }));
});
Identifier.displayName = "Notification.Identifier";

// src/Notification/index.tsx
var Notification = {
  Trigger: Trigger2,
  Marker: Marker3,
  Popover,
  Slide,
  Content: Content2,
  Header: Header2,
  Title,
  Body,
  Item,
  Icon,
  Message,
  Text,
  Description,
  Small,
  Footer,
  EmptyState,
  Identifier
};

// src/ImageCrop/Control/index.tsx
import { Slider } from "@77sol-ui/molecules";
import { forwardRef as forwardRef26 } from "react";
import { jsx as jsx38 } from "react/jsx-runtime";
var ImageCropControl = forwardRef26(
  (_a, ref) => {
    var rest = __objRest(_a, []);
    return /* @__PURE__ */ jsx38(Slider.Control, __spreadProps(__spreadValues({}, rest), { ref }));
  }
);
ImageCropControl.displayName = "ImageCrop.Control";

// src/ImageCrop/Crop/index.tsx
import {
  ImageCrop
} from "@77sol-ui/atoms";
import { forwardRef as forwardRef27 } from "react";
import { jsx as jsx39 } from "react/jsx-runtime";
var ImageCropContent = forwardRef27(
  (_a, ref) => {
    var rest = __objRest(_a, []);
    return /* @__PURE__ */ jsx39(ImageCrop, __spreadProps(__spreadValues({}, rest), { ref }));
  }
);
ImageCropContent.displayName = "ImageCrop.Crop";

// src/ImageCrop/Minus/index.tsx
import { Slider as Slider2 } from "@77sol-ui/molecules";
import { jsx as jsx40 } from "react/jsx-runtime";
function ImageCropMinus(_a) {
  var _b = _a, {
    className,
    onClick
  } = _b, rest = __objRest(_b, [
    "className",
    "onClick"
  ]);
  return /* @__PURE__ */ jsx40(Slider2.Minus, __spreadValues({ className, onClick }, rest));
}
ImageCropMinus.displayName = "ImageCrop.Minus";

// src/ImageCrop/Plus/index.tsx
import { Slider as Slider3 } from "@77sol-ui/molecules";
import { jsx as jsx41 } from "react/jsx-runtime";
function ImageCropPlus(_a) {
  var _b = _a, { className, onClick } = _b, rest = __objRest(_b, ["className", "onClick"]);
  return /* @__PURE__ */ jsx41(Slider3.Plus, __spreadValues({ className, onClick }, rest));
}
ImageCropPlus.displayName = "ImageCrop.Plus";

// src/ImageCrop/Actions/index.tsx
import { Slider as Slider4 } from "@77sol-ui/molecules";
import { jsx as jsx42 } from "react/jsx-runtime";
function ImageCropActionsRoot(_a) {
  var _b = _a, {
    className,
    children
  } = _b, rest = __objRest(_b, [
    "className",
    "children"
  ]);
  return /* @__PURE__ */ jsx42(Slider4.Root, __spreadProps(__spreadValues({ className }, rest), { children }));
}
ImageCropActionsRoot.displayName = "ImageCrop.Actions";

// src/ImageCrop/Root/styles.ts
var StyledImageCropRoot = ie({
  base: "org-flex org-flex-col org-gap-4"
});

// src/ImageCrop/Root/index.tsx
import { jsx as jsx43 } from "react/jsx-runtime";
function ImageCropRoot(_a) {
  var _b = _a, {
    className,
    children
  } = _b, rest = __objRest(_b, [
    "className",
    "children"
  ]);
  return /* @__PURE__ */ jsx43("div", __spreadProps(__spreadValues({ className: StyledImageCropRoot({ className }) }, rest), { children }));
}
ImageCropRoot.displayName = "ImageCrop.Root";

// src/ImageCrop/index.tsx
var ImageCrop2 = {
  Root: ImageCropRoot,
  Actions: ImageCropActionsRoot,
  Minus: ImageCropMinus,
  Plus: ImageCropPlus,
  Control: ImageCropControl,
  Crop: ImageCropContent
};

// src/UploadWithCrop/index.tsx
import {
  ImageCrop as ATMImageCrop,
  Button as Button4,
  Upload
} from "@77sol-ui/atoms";
import { Modal } from "@77sol-ui/molecules";
import { Scissors } from "lucide-react";
import { forwardRef as forwardRef28, useRef as useRef5, useState as useState3 } from "react";

// src/UploadWithCrop/hooks/useHandleZoom.tsx
import { useState as useState2 } from "react";
function useHandleZoom() {
  const [zoom, setZoom] = useState2(1);
  const zoomMin = 1;
  const zoomLimit = 100;
  const handleIncreaseZoom = () => {
    const addZoom = zoom === zoomLimit ? zoom : zoom + 0.5;
    setZoom(addZoom);
  };
  const handleDecreaseZoom = () => {
    const addZoom = zoom === zoomMin ? zoom : zoom - 0.5;
    setZoom(addZoom);
  };
  return { zoom, setZoom, handleIncreaseZoom, handleDecreaseZoom };
}

// src/UploadWithCrop/hooks/useUploadImage.tsx
import { useCallback } from "react";
function useGenerateFile({
  imageRef,
  mimeType = "image/png",
  fileName = "image_cropped",
  onSuccess
}) {
  const handleSave = useCallback(() => __async(this, null, function* () {
    if (imageRef == null ? void 0 : imageRef.current) {
      const canvasScaled = imageRef.current.getImageScaledToCanvas();
      const dataURL = canvasScaled.toDataURL(mimeType);
      const response = yield fetch(dataURL);
      const blob = yield response.blob();
      const file = new File([blob], fileName, { type: mimeType });
      onSuccess == null ? void 0 : onSuccess(file);
    }
  }), [onSuccess]);
  return { handleSave };
}

// src/UploadWithCrop/index.tsx
import { Fragment, jsx as jsx44, jsxs as jsxs6 } from "react/jsx-runtime";
var UploadWithCrop = forwardRef28(
  ({
    onSave,
    type = "square",
    desiredWidth,
    desiredHeight,
    modalTitle = "Ajuste sua imagem",
    modalDescription = "Redimensione sua imagem para se ajustar ao campo abaixo.",
    modalIcon: Icon2 = Scissors,
    uploadContainerWidth,
    uploadContainerHeight,
    uploadDescription = "PNG, JPG, GIF ou WEBP",
    previewValue,
    modalMaxWidth = "600px",
    modalMaxHeight = "80dvh",
    secondaryButtonText = "Cancelar",
    primaryButtonText = "Salvar",
    validTypes = ["image/png", "image/jpeg", "image/webp", "image/gif"],
    accept = ".png, .webp, .jpeg, .jpg, .gif",
    onRemoveFile,
    onCancelCrop,
    onUploadError,
    previewType = "icon",
    descriptionSize,
    iconContainerBorderWidth,
    iconContainerHeight,
    iconContainerWidth,
    iconSize,
    titleSize,
    iconGap
  }, ref) => {
    const [imageToCrop, setImageToCrop] = useState3(void 0);
    const imageRef = useRef5(null);
    function resetStates() {
      setZoom(1);
      setImageToCrop(void 0);
    }
    const { handleDecreaseZoom, handleIncreaseZoom, zoom, setZoom } = useHandleZoom();
    const { handleSave } = useGenerateFile({
      imageRef,
      fileName: imageToCrop == null ? void 0 : imageToCrop.name,
      mimeType: imageToCrop == null ? void 0 : imageToCrop.type,
      onSuccess: (file) => {
        onSave(file);
        resetStates();
      }
    });
    return /* @__PURE__ */ jsxs6(Fragment, { children: [
      /* @__PURE__ */ jsx44(
        Upload,
        {
          ref,
          iconGap,
          descriptionSize,
          iconContainerBorderWidth,
          iconContainerHeight,
          iconContainerWidth,
          iconSize,
          titleSize,
          previewValue,
          accept,
          validTypes,
          onUploadError,
          previewType,
          description: uploadDescription,
          onChange: (e) => {
            var _a, _b;
            if (e.type === "change" && "files" in e.target) {
              setImageToCrop((_a = e.target.files) == null ? void 0 : _a[0]);
            } else if (e.type === "drop" && "dataTransfer" in e) {
              setImageToCrop(
                (_b = e.dataTransfer.files) == null ? void 0 : _b[0]
              );
            }
          },
          onRemoveFile: () => {
            onRemoveFile();
            setImageToCrop(void 0);
          },
          title: "Clique para fazer o upload da imagem",
          width: uploadContainerWidth,
          height: uploadContainerHeight
        }
      ),
      /* @__PURE__ */ jsxs6(Modal.Root, { open: Boolean(imageToCrop), children: [
        /* @__PURE__ */ jsx44(Modal.Overlay, {}),
        /* @__PURE__ */ jsx44(Modal.Portal, { children: /* @__PURE__ */ jsxs6(
          Modal.Wrapper,
          {
            maxWidth: modalMaxWidth,
            maxHeight: modalMaxHeight,
            "data-testid": "crop-modal-wrapper",
            className: "!org-h-full !org-w-full",
            children: [
              /* @__PURE__ */ jsxs6(Modal.Header, { children: [
                /* @__PURE__ */ jsx44(Modal.Icon, { icon: Icon2, "data-testid": "crop-modal-icon" }),
                /* @__PURE__ */ jsx44(Modal.Title, { children: modalTitle }),
                /* @__PURE__ */ jsx44(Modal.Description, { children: modalDescription })
              ] }),
              /* @__PURE__ */ jsx44(Modal.Content, { className: "org-h-full", children: /* @__PURE__ */ jsx44(ImageCrop2.Root, { className: "org-flex org-justify-center org-items-center flex-col gap-4 org-rounded-xl org-h-full org-bg-black org-bg-opacity-85 [&>canvas]:org-rounded-xl [&>canvas]:!org-w-full [&>canvas]:!org-h-full [&>canvas]:org-object-contain", children: imageToCrop && /* @__PURE__ */ jsx44(
                ATMImageCrop,
                {
                  ref: imageRef,
                  image: imageToCrop,
                  width: desiredWidth,
                  height: desiredHeight,
                  zoom,
                  type,
                  border: 70,
                  color: [0, 0, 0, 0.6]
                }
              ) }) }),
              /* @__PURE__ */ jsxs6(ImageCrop2.Actions, { className: "org-mt-1 sm:org-mt-6 [&>button]:org-outline-gray-300 [&>input]:org-outline-gray-300", children: [
                /* @__PURE__ */ jsx44(ImageCrop2.Minus, { onClick: handleDecreaseZoom }),
                /* @__PURE__ */ jsx44(
                  ImageCrop2.Control,
                  {
                    name: "image-crop-control",
                    step: 0.01,
                    min: 1,
                    max: 100,
                    value: zoom,
                    onChange: (e) => {
                      setZoom(Number(e.target.value));
                    }
                  }
                ),
                /* @__PURE__ */ jsx44(ImageCrop2.Plus, { onClick: handleIncreaseZoom })
              ] }),
              /* @__PURE__ */ jsxs6(Modal.Footer, { className: "org-flex", children: [
                /* @__PURE__ */ jsx44(
                  Button4,
                  {
                    "data-testid": "button-cancel",
                    fullWidth: true,
                    variant: "outline",
                    onClick: () => {
                      onCancelCrop(imageToCrop);
                      resetStates();
                    },
                    children: secondaryButtonText
                  }
                ),
                /* @__PURE__ */ jsx44(
                  Button4,
                  {
                    "data-testid": "button-confirm",
                    fullWidth: true,
                    onClick: handleSave,
                    children: primaryButtonText
                  }
                )
              ] })
            ]
          }
        ) })
      ] })
    ] });
  }
);
export {
  Header,
  ImageCrop2 as ImageCrop,
  Notification,
  Sidebar,
  SidebarMobile,
  UploadWithCrop
};
